const feedbackWidget = document.querySelector('.feedback-widget')

feedbackWidget?.addEventListener('click', openFeedback)

function openFeedback() {
	feedbackWidget.classList.toggle('show')
	document.body.addEventListener('click', closeFeedbackOnOutsideClick)
}

function closeFeedbackOnOutsideClick(e) {
	if (!e.target.closest('.feedback-widget')) {
		feedbackWidget.classList.remove('show')
		document.body.removeEventListener('click', closeFeedbackOnOutsideClick)
	}
}
